import React from 'react';
import './style.css'; 

import img1 from '../../../Assets/developmentKit/1.webp'
import img2 from '../../../Assets/developmentKit/2.webp'
import img3 from '../../../Assets/developmentKit/3.webp'


// import bannerText from '../../../Assets/home/hero_section/banner_text.svg';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import Sliders from '../../../Molecules/Sliders';
import ImageLightbox, { useLightbox } from '../ImageLightbox';

import { Button } from "../../../Atoms";
import { useNavigate } from 'react-router-dom';
// import { IoChevronForwardOutline } from 'react-icons/io5';
// import { BsArrowRightShort } from 'react-icons/bs';

import banner1 from '../../../Assets/events/prawaasimg3.webp';
import banner2 from '../../../Assets/events/iievimg1.webp';
import banner3 from '../../../Assets/events/prawaasimg2.webp'; 

const bannerSection = [
  {
    src: banner1,
  },
  {
    src: banner2,
  },
  {
    src:  banner3,
  },
  
];

export default function Banner() {
  const navigate = useNavigate();
  const lightbox = useLightbox();
  const sliderContainerRef = React.useRef(null);

  const handleSliderClick = (e) => {
    if (!sliderContainerRef.current) return;

    // Ignore clicks on dots/arrows so slider controls still work normally
    if (e.target.closest('.slick-dots') || e.target.closest('.slick-arrow')) {
      return;
    }

    // In fade mode all slides stack at the same position; only the
    // slide react-slick marks .slick-active is the one actually visible.
    const activeImg = sliderContainerRef.current.querySelector('.slick-active img');
    if (activeImg) {
      lightbox.open(activeImg.src);
    }
  };

  return (
    <section className="banner flex bg-light-gradient pb-0 md:pb-28 lg:pb-40 pt-20 md:pt-28 lg:pt-40 my-10 xl:my-0 ">
      <div className="z-10 containers-min mx-auto sm:flex  md:flex-row flex-col sm:items-center ">
        <div className="md:w-6/12 h-fit flex justify-center items-start flex-col min-w-[300px] ">
        <div className="flex items-center gap-3 mb-4">
  <div className="w-1 h-5 bg-[rgb(35,180,85)] rounded-full"></div>
  <span className="text-[rgb(35,180,85)] font-poppins font-semibold text-xs tracking-[1.5px] uppercase">
    Where you&apos;ll find us
  </span>
</div>
          <h1 className="leading-tight !h3 font-gilroylight font-light">
              News &amp; <span className="font-gilroybold">Events</span>
            <br />
           
          </h1>
          <h5 className="lg:mt-6 mt-4 font-poppins md:text-2xl text-lg">
            From industry events and conference stages to awards, media features, and speaking engagements, discover the milestones, achievements, and stories shaping VerdeMobility's journey in electric mobility. Explore our upcoming events and look back at the moments that bring us closer to the EV charging community.
          </h5>
           
           {/* <Button
            title="Get in Touch"
            onClick={() => navigate('/get-in-touch')}
            className="mt-6"
          /> */}
        </div>

        <div
          className="md:w-5/12 w-full p-4 md:mt-0 mt-10 mx-auto relative lg:min-h-[500px] min-h-[300px]"
          ref={sliderContainerRef}
          // onClick={handleSliderClick}
        >
          <Sliders data={bannerSection} classname="lg:min-h-[400px] w-full  shadow-[0_0_20px_rgba(0,0,0,0.1)] object-cover rounded-[10px]" settings={{ speed: 800, autoplay: true, autoplaySpeed: 2000 }}/>
        </div>
      </div>
       <ImageLightbox {...lightbox} alt="VerdeMobility banner" />
    </section>
  );
}